/*!

=========================================================
* BootstrapVue Argon Dashboard PRO - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/bootstrap-vue-argon-dashboard-pro
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from 'vue';
import DashboardPlugin from './plugins/dashboard-plugin';
import App from './App.vue';
import Vuex from 'vuex'
import store from './store'
import DateFilter from '@/common/date.filter'
import DateShortFilter from '@/common/dateShort.filter'
import DateTimeFilter from '@/common/dateTime.filter'
import TimeFilter from '@/common/time.filter'
import VueJWT from 'vuejs-jwt'
const punycode = require('punycode');

import ApiService from '@/common/api.service'

// router setup
import router from "./routes/router";
// plugin setup


//Vue.prototype.$AuthService = new AuthService()

Vue.use(DashboardPlugin);
Vue.use(Vuex)

Vue.use(VueJWT)
Vue.filter('formatDate', DateFilter)
Vue.filter('formatDateTime', DateTimeFilter)
Vue.filter('formatDateShort', DateShortFilter)
Vue.filter('formatTime', TimeFilter)

import { extend } from 'vee-validate';

extend('nospace', value => {
  // if the field is empty
  if (!value) {
    return 'This field is required';
  }
  // if the field is not a valid email
  const test = value.trim().match(/\s/g);
  if(test && test.length > 0){
    return 'Empty spaces are not allowed!';
  }
  // All is good
  return true;
});

extend('url_idn', value => {
  // if the field is empty
  if (!value) {
    return 'This field is required';
  }
  // if the field is not a valid email
  const asciiValue = punycode.toASCII(value);
  const isValid = /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,10}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi.test(asciiValue);
  if(!isValid){
    return 'The url field format is invalid';
  }
  // All is good
  return true;
});

extend('url_idn_v2', value => {
  // if the field is empty
  if (!value) {
    return 'This field is required';
  }
  // if the field is not a valid email
  const asciiValue = punycode.toASCII(value);
  
  const regex = /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[0-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
  if (!regex.test(asciiValue)) {
    return 'The url field format is invalid';
  }

  // All is good
  return true;
});

extend('email_custom', value => {
  // if the field is empty
  if (!value) {
    return 'This field is required';
  }
  // if the field is not a valid email
  //var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF\-0-9]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/;

  const isValid = re.test(String(value).toLowerCase());
  if(!isValid){
    return 'The url field format is invalid';
  }

  // All is good
  return true;
});

ApiService.init()

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router,
  store
});
